import styled from "styled-components";
import {
  Button,
  Form,
  FormGroup,
  OverlayTrigger,
  Popover,
} from "react-bootstrap";
import {
  GridForm,
  GridFormItemWrapper,
  TooltipProvider,
} from "@bagel-web/components";
import { useAgentViewPreferences } from "./agentViewPreferences";

const StyledPopover = styled(Popover)`
  max-width: fit-content;
`;

const AgentViewPreferencesForm = () => {
  const { showCompactStateContent, setShowCompactStateContent } =
    useAgentViewPreferences();

  return (
    <GridForm $numCols={1}>
      <FormGroup>
        <h6>General</h6>
        <GridFormItemWrapper>
          <Form.Check
            type="switch"
            checked={!showCompactStateContent}
            onChange={(e) => {
              setShowCompactStateContent(!e.target.checked);
            }}
            label="Show whitespace in message content"
          />
        </GridFormItemWrapper>
      </FormGroup>
    </GridForm>
  );
};

const AgentViewPreferencesButton = () => {
  const popover = (
    <StyledPopover>
      <Popover.Body>
        <AgentViewPreferencesForm />
      </Popover.Body>
    </StyledPopover>
  );

  return (
    <TooltipProvider tooltip="Settings">
      <OverlayTrigger
        trigger="click"
        rootClose
        placement="auto"
        overlay={popover}
      >
        <Button className="bi-gear-fill" variant="secondary" />
      </OverlayTrigger>
    </TooltipProvider>
  );
};

export default AgentViewPreferencesButton;
